<div class="app-root">
  <router-outlet />
  <div
    toastContainer
    id="toast-container"
    class="toast-container fixed top-0 left-1/2 transform -translate-x-1/2 w-full max-w-xs h-10"
    aria-live="polite"
  ></div>
</div>
